import { render, staticRenderFns } from "./ImageElementPublish.vue?vue&type=template&id=58a6e791&"
import script from "./ImageElementPublish.vue?vue&type=script&lang=ts&"
export * from "./ImageElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./ImageElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports